import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const { defaultTitle } = useTitle();
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/policy.txt`)
      .then((res) => res.text())
      .then(setContent)
      .catch((err) => console.error('Failed to load privacy policy:', err));
  }, []);
  return (
    <div style={{ padding: '20px', whiteSpace: 'pre-wrap' }}>
      <Helmet>
        <title>{`${defaultTitle} - プライバシーポリシー`}</title>
      </Helmet>
      <h1>プライバシーポリシー</h1>
      <div>{content}</div>
    </div>
  );
};

export default PrivacyPolicy;